import { SignInComponent } from './signin.component';

export const SignInRoutes: Array<any> = [
  {path: 'api/signin', component: SignInComponent},
];



// WEBPACK FOOTER //
// ./src/app/components/signin/signin.routes.ts